import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Dices, RefreshCw, Sparkles } from 'lucide-react';

/**
 * Home hero card that invites users to open "Cosa guardare oggi".
 * Blue → gold gradient, discreet auto-update badge, big dice CTA.
 */
export default function SurpriseMeCard() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="mb-3"
    >
      <Link
        to="/consigli-oggi"
        data-testid="surprise-me-card"
        className="block relative overflow-hidden rounded-2xl p-5 border border-[var(--gold)]/30 shadow-lg shadow-black/40 transition-transform duration-300 hover:scale-[1.015] active:scale-[0.98]"
        style={{
          backgroundImage: 'linear-gradient(135deg, #0b1f4a 0%, #1a2b5a 40%, #2a1d0a 80%, #4a3110 100%)',
        }}
      >
        {/* decorative sparkles */}
        <Sparkles className="absolute -top-1 -right-1 w-24 h-24 text-[var(--gold)]/10 rotate-12 pointer-events-none" />
        <Dices className="absolute -bottom-3 -left-3 w-20 h-20 text-white/5 -rotate-12 pointer-events-none" />

        <div className="relative">
          <div className="flex items-center gap-1.5 mb-3">
            <RefreshCw className="w-2.5 h-2.5 text-[var(--gold)]/70" />
            <span className="text-[9px] uppercase tracking-[0.25em] text-[var(--gold)]/70">Aggiornato automaticamente ogni giorno</span>
          </div>

          <div className="flex items-center gap-2 mb-1.5">
            <span className="text-2xl">🍿</span>
            <h3 className="font-heading text-xl sm:text-2xl font-light">Non sai cosa guardare?</h3>
            <Dices className="w-5 h-5 text-[var(--gold)] animate-[wiggle_3s_ease-in-out_infinite]" />
          </div>

          <p className="text-xs sm:text-sm text-white/70 leading-relaxed max-w-md">
            Lasciati sorprendere! Ogni giorno Golden Connect seleziona automaticamente
            <span className="text-[var(--gold)] font-semibold"> 8 film </span>
            e
            <span className="text-[var(--gold)] font-semibold"> 8 serie TV </span>
            da scoprire.
          </p>

          <div className="mt-4">
            <div
              data-testid="surprise-me-btn"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-[var(--gold)] text-black font-bold text-sm shadow-md shadow-[var(--gold)]/20 hover:brightness-110 transition"
            >
              <Dices className="w-4 h-4" />
              Sorprendimi
            </div>
          </div>
        </div>
      </Link>

      <style>{`@keyframes wiggle {
        0%, 100% { transform: rotate(-8deg); }
        50% { transform: rotate(8deg); }
      }`}</style>
    </motion.div>
  );
}
